import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { Children, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import './pageless-footer.scss';

type Props = {
  maxItemsCount: number;
  isTruncated: boolean;
};

export function PageLessFooter({ children, maxItemsCount, isTruncated }: PropsWithChildren<Props>) {
  const hasChildren = Children.count(children) > 0;
  if (!isTruncated && !hasChildren) {
    return null;
  }

  return (
    <GenericErrorBoundary>
      <div className="pageless-footer" role="status">
        <div className="d-flex justify-content-start align-items-end">
          {hasChildren && <div className="flex-grow-1 align-self-center ms-auto ps-1">{children}</div>}
          {isTruncated && (
            <div className="fs-12 ps-3">
              <FormattedMessage
                id="blotter.footer.tooManyRows"
                values={{ maxItemsCount: `${maxItemsCount / 1_000} K` }}
              />
            </div>
          )}
        </div>
      </div>
    </GenericErrorBoundary>
  );
}
